import React, { useEffect, useState } from 'react';
import { fetchBolsasMaisAcesso } from 'services/AutoApprovalService/requests';
import { ContainerStyled, LinkStyled } from './style';

function MenuSecundario(props) {
  const user = JSON.parse(localStorage.getItem('usuarioIES') || '{}');
  const showAccountInfoPage =
    ['GESTOR_VALORES', 'ADMINISTRADOR_IES'].indexOf(user?.perfil) > -1;
  const [hasMaisAcesso, setHasMaisAcesso] = useState<boolean>(false);

  useEffect(() => {
    fetchBolsasMaisAcesso().then((response) => {
      setHasMaisAcesso(response.data.bolsas.length > 0);
    });
  }, []);
  return (
    <ContainerStyled>
      {showAccountInfoPage && (
        <LinkStyled to="/dados-financeiros" activeClassName="active">
          Dados Financeiros
        </LinkStyled>
      )}
      {hasMaisAcesso && (
        <LinkStyled to="/aprovacao-automatica" activeClassName="active">
          Aprovação automática
        </LinkStyled>
      )}
      <LinkStyled to="/trocar-Senha" activeClassName="active">
        Trocar Senha
      </LinkStyled>
      <LinkStyled to="/perfil" activeClassName="active">
        Perfil
      </LinkStyled>
    </ContainerStyled>
  );
}

export default MenuSecundario;
